import { TDataTablePagination } from '../../components/Tables/DataTable'

export enum SalesTeamRulesStep {
  List,
  ChooseFor,
  Rule,
  Products,
  Members,
}

export enum TeamRulesTypeEnum {
  Leader = 1,
  Member = 2,
}

export enum TeamRulesTargetEnum {
  Commission = 1,
  VGV = 2,
}

export enum SalesReconciliatonStatusEnum {
  Active = 1,
  Processing = 2,
  Paid = 3,
  Failed = 4,
}

export interface GetSalesTeamProps {
  page: number
  rows: number
  search?: string
}

export type SalesTeamLeader = {
  id: string
  tenantId: string
  codeId: string
  name: string
  email: string
  quantidadeVendas: number
  totalVendas: number
}

export type SalesTeamLeaderItemList = {
  id: string
  tenantId: string
  codeId: string
  name: string
  email: string
  salesQuantity: number
  totalSold: number
}

export type SalesTeam = {
  id: string
  codeId: string
  name: string
  teamLeader: SalesTeamLeader
  members: SalesTeamLeader[]
}

export type SalesTeamRanking = {
  id: string
  codeId: string
  name: string
  teamLeader: string
  members: string[]
  salesQuantity: number
  totalSold: number
  commissions: number
}

export type SalesTeamSearchTenant = {
  id: string
  name: string
}

export type SalesTeamRequest = {
  id?: string
  codeId?: string
  name: string
  tenantTeamLeaderId?: string
  membersIds: string[]
}

export type SalesTeamMember = {
  id: string
  tenantName: string
  tenantId: string
  tenantEmail: string
}

export type SalesTeamSeller = {
  conciliationId: string
  memberId?: string | null
  teamLeaderId?: string | null
  codeId: string
  type: string
  name: string
  email: string
  vgv: number
  salesQuantity: number
  commission: number
  conciliationAmount: number
  teamName: string
  teamCodeId: string
}

export type SalesTeamConciliationPagination =
  TDataTablePagination<SalesTeamSeller>

export type SalesTeamPagination = TDataTablePagination<SalesTeamRanking>

export type SalesTeamCommissionRuleProduct = {
  id: string
  name: string
  productId: string
}

export type SalesTeamCommissionRuleTeam = {
  id: string
  name: string
  salesId: string
}

export type SalesTeamCommissionRuleLeader = {
  id: string
  name: string
  teamLeaderId: string
}

export type SalesTeamCommissionRule = {
  id: string
  codeId: string
  tenantId: string
  identifier: string
  ruleType: TeamRulesTypeEnum
  ruleTargetMeta: TeamRulesTargetEnum
  targetMeta: number
  commission: number
  globalCommission: number
  endDate: Date | null
  restartCommission: boolean
  salesTeam: SalesTeamCommissionRuleTeam[]
  teamLeaders: SalesTeamCommissionRuleLeader[]
  members: string[]
  products: SalesTeamCommissionRuleProduct[]
}

export type SalesTeamCommissionRuleRequest = {
  identifier: string
  ruleType: TeamRulesTypeEnum
  ruleTargetMeta: TeamRulesTargetEnum
  targetMeta: number
  commission: number
  globalCommission: number
  endDate: Date | null
  salesTeams: string[]
  teamLeaders: string[]
  members: string[]
  products: string[]
}

export type SalesTeamRuleItem = {
  id: string
  tenantId: string
  codeId: string
  identifier: string
  ruleType: TeamRulesTypeEnum
  ruleTargetMeta: TeamRulesTargetEnum
  targetMeta: number
  commission: number
}

export type SalesTeamRulePagination = TDataTablePagination<SalesTeamRuleItem>

export type SalesTeamSalesItem = {
  id: string
  codeId: string
  tenantName: string
  commission: number
  percentage: number
  productName: string
}

export type SalesTeamSalesPagination = TDataTablePagination<SalesTeamSalesItem>

export type SalesConciliation = {
  id: string
  codeId: string
  referenceDate: string
  tenantId: string
  tenantName: string
  sellerId: string
  sellerName: string
  salesTeamId: string
  salesTeamName: string
  salesTeamCode: string
  memberId: string
  memberName: string
  memberCode: string
  leaderId: string
  leaderName: string
  leaderCode: string
  status: SalesReconciliatonStatusEnum
  commissionsReceived: number
  commissionsDue: number
  pendingAmount: number
  totalSold: number
  chargeId: string
}

export type SalesTeamWhitdraw = {
  tenantId: string
  tenantName: string
  tenantEmail: string
  balanceAmount: number
  withdrawAmountReleased: number
}

export type SalesTeamWhitdrawPagination =
  TDataTablePagination<SalesTeamWhitdraw>

export type SalesTeamWhitdrawRequest = {
  tenantId: string
  withdrawAmountReleased: number
}

export type SalesTeamExternalSale = {
  id: string
  identifier: string
  createdDate: Date
  referenceDate: Date
  codeId: string
  salesTeamId: string
  salesTeamName: string
  sellerId: string
  sellerName: string
  sellerEmail: string
  /*productId: string
  productName: string
  productPriceId: string
  offerName: string*/
  totalSold: number
  commission: number
  quantity: number
  customerName: string
  customerEmail: string
}

export type SalesTeamExternalSalePagination =
  TDataTablePagination<SalesTeamExternalSale>

export type TSalesTeamContext = {
  rowsPerPage: number
  setRowsPerPage: (value: number) => void
  pagination: SalesTeamPagination | null
  setPagination: (value: SalesTeamPagination | null) => void
  stepRule: SalesTeamRulesStep
  setStepRule: (value: SalesTeamRulesStep) => void
  commissionRule: SalesTeamCommissionRule | null
  setCommissionRule: (value: SalesTeamCommissionRule | null) => void
  isCurrentTeamLeader: () => boolean
  current: SalesTeam | null
  setCurrent: (value: SalesTeam | null) => void
  referenceDate: Date
  setReferenceDate: (value: Date) => void
  externalSale: SalesTeamExternalSale | null
  setExternalSale: (value: SalesTeamExternalSale | null) => void
}
